<template>
  <div class="speed-box" id="jzzhurenzhici">
    <div class="speed-wrap inner">
      <div class="speed-left">
        <div class="speed-imgs">
          <img src="../../assets/img/7.png" alt=""/>
        </div>
        <div class="speed-info">
          <div class="speed-tops">
            <strong>{{speedData.title}}</strong>
            <p>{{speedData.entitle}}</p>
          </div>
          <div class="speed-heade" v-if="speedData.description != null" v-html="speedData.desc"></div>
           <!-- <div class="speed-heade">
             <p>四川大学华西医院/华西临床医学院院长</p>
             <p>教育部疾病分子网络前沿科学中心主任</p>
             <p>四川大学华西医院呼吸健康研究所所长</p>
             <p>担任中华医学会副会长、中国医师协会副会长、中华医学会呼吸病学分会副主任委员、四川省医学会呼吸专委会主任委员等</p>
             <p>获国家科技进步二等奖、四川省科技进步一等奖、全国创新争先奖、“天府青城计划”天府杰出科学家、吴阶平-保罗·杨森医学药学奖</p>
           </div> -->
        </div>
      </div>
      <div class="message">
        <div class="message-title"><strong>主任致辞</strong></div>
        <div class="message-info" v-html="speedData.content">
        </div>
        <!-- <div class="message-info">
          <p style="text-indent: 36px;">精准医学是医学发展史上继传统医学、循证医学之后的第三次革命性飞跃，是未来医疗健康发展的制高点，更是国家竞争力的重要体现。</p>
          <br>
          <p style="text-indent: 36px;">2015年，习近平总书记批示科技部、卫计委成立中国精准医疗战略专家组，精准医学上升为国家战略。四川大学华西医院于同年成立精准医学中心。2018年，“国家产业创新中心”启动布局后，医院联合10家企业成立“华西精准医学产业创新中心有限公司”，并在四川省委省政府主要领导关怀支持下，正式启动“国家精准医学产业创新中心”创建工作。2022年1月，中心获批组建，3月正式揭牌。至此，中国生物医药领域首个、精准医学方向唯一的国家产业创新中心应运而生。</p>
          <br>
          <p style="text-indent: 36px;">未来5年，国家精准医学产业创新中心将重点建设和推动精准诊断、精准治疗、精准评价和精准医学战略资源库等重点领域的科技创新、成果转移转化和产业化，围绕肿瘤、感染性疾病、罕见病、遗传病等疑难疾病，形成一批基础研究和应用基础研究的原创性成果，突破分子诊断、医学人工智能、靶向药物、细胞治疗、生物医学材料、创新医疗器械等关键核心技术，促进相关技术和产品的临床应用，成为精准医学的成果转化中心和医药创新产品孵化器。</p>
        </div> -->
        <div class="message-sp">
          <img src="../../assets/images/message.png" alt=""/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      speedData: {}
    }
  },
  methods: {
    async getData () {
      const { data: res } = await this.$http.get('/fdata/article_pagelist_show?catid=85')
      if (res.code === 1) {
        this.speedData = res.data.info[0]
        console.log(this.speedData)
      }
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/about/index.less");
</style>
